import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "library-album"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "library-album-files" }
const _hoisted_4 = { class: "library-album-img-table-img" }
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = { class: "library-audio-files-table" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "library-nowrap-text" }
const _hoisted_12 = { class: "library-nowrap-text" }
const _hoisted_13 = { class: "library-audio-files-table-duration" }
const _hoisted_14 = { class: "library-audio-files-table-rating" }
const _hoisted_15 = { class: "library-audio-files-table-count" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = { key: 1 }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_20 = { class: "library-album-table-duration" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_24 = { key: 1 }
const _hoisted_25 = ["src"]
const _hoisted_26 = { class: "library-album-files" }
const _hoisted_27 = { class: "library-audio-files-table" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { class: "library-nowrap-text" }
const _hoisted_30 = { class: "library-nowrap-text" }
const _hoisted_31 = { class: "library-audio-files-table-duration" }
const _hoisted_32 = { class: "library-audio-files-table-rating" }
const _hoisted_33 = { class: "library-audio-files-table-count" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = { key: 1 }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_38 = { class: "library-album-table-duration" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("td", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_audio_rating_2 = _resolveComponent("audio-rating-2")!

  return (_ctx.album)
    ? (_openBlock(), _createElementBlock("table", _hoisted_1, [
        (_ctx.isMobile)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_2, [
              _createElementVNode("td", _hoisted_3, [
                _createElementVNode("table", {
                  class: "library-album-img-table",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectAudioAlbum(_ctx.album)))
                }, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_4, [
                      _createElementVNode("img", {
                        class: "library-album-img",
                        loading: "lazy",
                        src: 'https://backend.vdmar.ru/storage/images/' + _ctx.album.id + '/2.jpg'
                      }, null, 8, _hoisted_5)
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.album.artist), 1),
                      _hoisted_6,
                      _createElementVNode("span", null, _toDisplayString(_ctx.album.year), 1),
                      _hoisted_7,
                      _createElementVNode("span", null, _toDisplayString(_ctx.album.name), 1),
                      _hoisted_8
                    ])
                  ])
                ]),
                _createElementVNode("table", _hoisted_9, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.audioFilesPreview, (audioFile) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: audioFile.id,
                      class: _normalizeClass(["library-audio-files-table-tr", audioFile.selected ? 'library-audio-files-table-tr-selected' : '']),
                      style: _normalizeStyle(audioFile.state == 1 || audioFile.state == 2 ? 'display: none' : 'display: table-row'),
                      onClick: ($event: any) => (_ctx.selectAudioTrack(audioFile))
                    }, [
                      _createElementVNode("td", {
                        class: "library-audio-files-table-name",
                        style: _normalizeStyle(_ctx.styleObjectTableName)
                      }, [
                        _createElementVNode("span", _hoisted_11, _toDisplayString(audioFile.trackNo + ' . ' + audioFile.title), 1)
                      ], 4),
                      _createElementVNode("td", {
                        class: "library-audio-files-table-genre",
                        style: _normalizeStyle(_ctx.styleObjectGenre)
                      }, [
                        _createElementVNode("span", _hoisted_12, _toDisplayString(audioFile.genre), 1)
                      ], 4),
                      _createElementVNode("td", _hoisted_13, _toDisplayString(_ctx.getAudioFileLastDuration(+audioFile.duration)), 1),
                      _createElementVNode("td", _hoisted_14, [
                        _createVNode(_component_audio_rating_2, {
                          rating: audioFile.rating,
                          fileId: audioFile.id
                        }, null, 8, ["rating", "fileId"])
                      ]),
                      _createElementVNode("td", _hoisted_15, _toDisplayString(audioFile.count != 0 ? audioFile.count : ''), 1),
                      _withDirectives(_createElementVNode("td", {
                        class: "library-audio-files-table-lastPlayed",
                        style: _normalizeStyle(_ctx.styleObjectLastPlayed)
                      }, _toDisplayString(audioFile.count != 0 ? _ctx.getAudioFileLastPlayed(audioFile.lastPlayed) : ''), 5), [
                        [_vShow, _ctx.showTime]
                      ])
                    ], 14, _hoisted_10))
                  }), 128)),
                  (_ctx.album.audioFiles.length < 10)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList((10 - _ctx.album.audioFiles.length), (item, index) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: index,
                          style: {"height":"17px"}
                        }, _hoisted_17))
                      }), 128))
                    : _createCommentVNode("", true),
                  _createElementVNode("tr", null, [
                    (_ctx.album.audioFiles.filter((el) => el.state !== 1 && el.state !== 2).length >= 11)
                      ? (_openBlock(), _createElementBlock("td", {
                          key: 0,
                          class: "library-audio-files-table-add",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.fullAlbum = !_ctx.fullAlbum))
                        }, _toDisplayString(_ctx.fullAlbum ? 'Убрать' : 'Показать все ' + _ctx.album.audioFiles.filter((el) =>
                                    el.state !== 1 && el.state !== 2).length + ' трэков'), 1))
                      : (_openBlock(), _createElementBlock("td", _hoisted_18)),
                    _hoisted_19,
                    _createElementVNode("td", _hoisted_20, _toDisplayString(_ctx.getAlbumDuration(_ctx.album)), 1),
                    _hoisted_21,
                    _hoisted_22,
                    _hoisted_23
                  ])
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("tr", _hoisted_24, [
              _createElementVNode("td", {
                class: "library-album-img-td",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectAudioAlbum(_ctx.album)))
              }, [
                _createElementVNode("span", null, _toDisplayString(_ctx.album.artist), 1),
                _createElementVNode("img", {
                  class: "library-album-img",
                  loading: "lazy",
                  src: 'https://backend.vdmar.ru/storage/images/' + _ctx.album.id + '/2.jpg'
                }, null, 8, _hoisted_25),
                _createElementVNode("span", null, _toDisplayString(_ctx.album.year + " - " + _ctx.album.name), 1)
              ]),
              _createElementVNode("td", _hoisted_26, [
                _createElementVNode("table", _hoisted_27, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.audioFilesPreview, (audioFile) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: audioFile.id,
                      class: _normalizeClass(["library-audio-files-table-tr", audioFile.selected ? 'library-audio-files-table-tr-selected' : '']),
                      style: _normalizeStyle(audioFile.state == 1 || audioFile.state == 2 ? 'display: none' : 'display: table-row'),
                      onClick: ($event: any) => (_ctx.selectAudioTrack(audioFile))
                    }, [
                      _createElementVNode("td", {
                        class: "library-audio-files-table-name",
                        style: _normalizeStyle(_ctx.styleObjectTableName)
                      }, [
                        _createElementVNode("span", _hoisted_29, _toDisplayString(audioFile.trackNo + ' . ' + audioFile.title), 1)
                      ], 4),
                      _createElementVNode("td", {
                        class: "library-audio-files-table-genre",
                        style: _normalizeStyle(_ctx.styleObjectGenre)
                      }, [
                        _createElementVNode("span", _hoisted_30, _toDisplayString(audioFile.genre), 1)
                      ], 4),
                      _createElementVNode("td", _hoisted_31, _toDisplayString(_ctx.getAudioFileLastDuration(+audioFile.duration)), 1),
                      _createElementVNode("td", _hoisted_32, [
                        _createVNode(_component_audio_rating_2, {
                          rating: audioFile.rating,
                          fileId: audioFile.id
                        }, null, 8, ["rating", "fileId"])
                      ]),
                      _createElementVNode("td", _hoisted_33, _toDisplayString(audioFile.count != 0 ? audioFile.count : ''), 1),
                      _withDirectives(_createElementVNode("td", {
                        class: "library-audio-files-table-lastPlayed",
                        style: _normalizeStyle(_ctx.styleObjectLastPlayed)
                      }, _toDisplayString(audioFile.count != 0 ? _ctx.getAudioFileLastPlayed(audioFile.lastPlayed) : ''), 5), [
                        [_vShow, _ctx.showTime]
                      ])
                    ], 14, _hoisted_28))
                  }), 128)),
                  (_ctx.album.audioFiles.length < 10)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList((10 - _ctx.album.audioFiles.length), (item, index) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: index,
                          style: {"height":"17px"}
                        }, _hoisted_35))
                      }), 128))
                    : _createCommentVNode("", true),
                  _createElementVNode("tr", null, [
                    (_ctx.album.audioFiles.filter((el) => el.state !== 1 && el.state !== 2).length >= 11)
                      ? (_openBlock(), _createElementBlock("td", {
                          key: 0,
                          class: "library-audio-files-table-add",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.fullAlbum = !_ctx.fullAlbum))
                        }, _toDisplayString(_ctx.fullAlbum ? 'Убрать' : 'Показать все ' + _ctx.album.audioFiles.filter((el) =>
                                    el.state !== 1 && el.state !== 2).length + ' трэков'), 1))
                      : (_openBlock(), _createElementBlock("td", _hoisted_36)),
                    _hoisted_37,
                    _createElementVNode("td", _hoisted_38, _toDisplayString(_ctx.getAlbumDuration(_ctx.album)), 1),
                    _hoisted_39,
                    _hoisted_40,
                    _hoisted_41
                  ])
                ])
              ])
            ]))
      ]))
    : _createCommentVNode("", true)
}